/**
 * SORA post-purchase thank-you page — confetti, order anchor, staggered timeline.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "sora_thankyou_v1";
  var MAX_AGE_MS = 30 * 60 * 1000;

  function parseQuery() {
    var params = new URLSearchParams(window.location.search);
    return {
      order: params.get("order"),
      fgas: params.get("fgas") === "1",
    };
  }

  function readStorage() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.ts || Date.now() - data.ts > MAX_AGE_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderOrder(ctx) {
    var orderEl = document.getElementById("sora-thankyou-order");
    var numEl = document.querySelector("[data-order-number]");
    if (!orderEl || !numEl) return;

    var num = ctx.orderNumber || ctx.order;
    if (!num) return;

    numEl.textContent = "#" + num;
    orderEl.hidden = false;

    var fgasStep = document.getElementById("sora-thankyou-fgas");
    if (fgasStep && (ctx.hasFgas || ctx.fgas)) {
      fgasStep.hidden = false;
    }

    var itemsWrap = document.getElementById("sora-thankyou-items");
    var list = document.querySelector("[data-item-list]");
    var items = ctx.items || [];
    if (itemsWrap && list && items.length) {
      itemsWrap.hidden = false;
      list.innerHTML = items
        .map(function (item) {
          var thumb = item.image
            ? '<img class="sora-thankyou__item-thumb" src="' +
              escapeHtml(item.image) +
              '" alt="" width="52" height="52" loading="lazy">'
            : '<div class="sora-thankyou__item-thumb" aria-hidden="true"></div>';
          var meta = item.vendor ? escapeHtml(item.vendor) : "";
          if (item.quantity > 1) {
            meta = (meta ? meta + " · " : "") + "Qty " + item.quantity;
          }
          return (
            '<li class="sora-thankyou__item">' +
            thumb +
            '<div class="sora-thankyou__item-body">' +
            '<p class="sora-thankyou__item-title">' +
            escapeHtml(item.title) +
            "</p>" +
            (meta ? '<p class="sora-thankyou__item-meta">' + meta + "</p>" : "") +
            "</div></li>"
          );
        })
        .join("");
    }
  }

  function staggerSteps() {
    var steps = document.querySelectorAll(".sora-thankyou__step:not([hidden])");
    steps.forEach(function (step, i) {
      setTimeout(function () {
        step.classList.add("is-visible");
      }, 700 + i * 120);
    });
  }

  function confettiBurst() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var canvas = document.getElementById("sora-thankyou-confetti");
    if (!canvas) return;

    var ctx = canvas.getContext("2d");
    var dpr = window.devicePixelRatio || 1;
    var w = (canvas.width = window.innerWidth * dpr);
    var h = (canvas.height = window.innerHeight * dpr);
    canvas.style.width = window.innerWidth + "px";
    canvas.style.height = window.innerHeight + "px";
    ctx.scale(dpr, dpr);

    var colors = ["#7eb8c9", "#2f6f7e", "#3a6d7a", "#c5d8e0", "#e8f1f4"];
    var particles = [];
    var count = 48;
    var cx = window.innerWidth / 2;
    var cy = window.innerHeight * 0.28;

    for (var i = 0; i < count; i++) {
      var angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.4;
      var speed = 2.5 + Math.random() * 4;
      particles.push({
        x: cx,
        y: cy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 2,
        size: 4 + Math.random() * 5,
        color: colors[i % colors.length],
        life: 1,
        decay: 0.012 + Math.random() * 0.008,
        rot: Math.random() * Math.PI,
        spin: (Math.random() - 0.5) * 0.2,
      });
    }

    var start = performance.now();
    var duration = 2400;

    function frame(now) {
      var elapsed = now - start;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

      var alive = false;
      for (var j = 0; j < particles.length; j++) {
        var p = particles[j];
        if (p.life <= 0) continue;
        alive = true;
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.06;
        p.life -= p.decay;
        p.rot += p.spin;

        ctx.save();
        ctx.globalAlpha = Math.max(0, p.life);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        ctx.restore();
      }

      if (alive && elapsed < duration) {
        requestAnimationFrame(frame);
      } else {
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      }
    }

    requestAnimationFrame(frame);
  }

  function initReveal() {
    document.documentElement.classList.add("sora-reveal-ready");
    var root = document.getElementById("sora-thankyou-root");
    if (root) root.classList.add("is-revealed");
  }

  function boot() {
    initReveal();
    var qs = parseQuery();
    var stored = readStorage();
    var ctx = stored || {};
    if (qs.order) ctx.orderNumber = qs.order;
    if (qs.fgas) ctx.fgas = true;
    renderOrder(ctx);
    staggerSteps();
    setTimeout(confettiBurst, 400);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
